import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/timetable-day2.jpg")